import React from 'react';
import { useParams } from 'react-router-dom';
import { PageContainer } from '@ant-design/pro-layout';
import { useQuery } from '@apollo/client';
import { Descriptions, Button, Divider } from 'antd';
import { PlusOutlined, EditOutlined } from '@ant-design/icons';
import ProjectHeader from '../../ProjectHeader';
import { GET_BUDGET } from '../../../../gql/budgets';
import { CurrencyDisplay, Link } from '../../../layout';
import VirementsTable from '../BudgetVirment/components/VirementsTable';
import PrivateComponentInProject from '../../../auth/PrivateComponentInProject';
import useProjectFrozen from 'hooks/useProjectFrozen';

const Budget = () => {
  const { id, projectId } = useParams();
  const projectFrozen = useProjectFrozen(projectId);
  const { data, loading } = useQuery(GET_BUDGET, {
    variables: {
      ids: [id],
      virementStatus: ['DRAFT', 'PENDING', 'APPROVED', 'REJECTED', 'VOIDED'],
    },
  });

  const budget = data?.budgets[0];

  return (
    <ProjectHeader>
      <PageContainer
        title={budget?.budgetCategory.name}
        subTitle="Budget Detail"
        loading={loading}
        extra={[
          !projectFrozen && (
            <PrivateComponentInProject expectedScopeType={['WRITE_BUDGET']}>
              <Link
                to={`/projects/${projectId}/budget-virement/budgets/${id}/edit`}
              >
                <Button type="primary" icon={<EditOutlined />}>
                  Edit Budget
                </Button>
              </Link>
            </PrivateComponentInProject>
          ),
        ]}
      >
        <Descriptions column={{ xxl: 3, xl: 3, lg: 3, md: 3, sm: 1, xs: 1 }}>
          <Descriptions.Item label="Budget Category" span={3}>
            {budget?.budgetCategory.name}
          </Descriptions.Item>
          <Descriptions.Item label="Balance after Virement">
            <CurrencyDisplay amount={budget?.balance} />
          </Descriptions.Item>
          <Descriptions.Item label="Approved Funding">
            <CurrencyDisplay amount={budget?.approvedFunding} />
          </Descriptions.Item>
          <Descriptions.Item label="Additional Funding">
            <CurrencyDisplay amount={budget?.additionalFunding} />
          </Descriptions.Item>
          <Descriptions.Item label="Remarks" span={3}>
            {budget?.remarks}
          </Descriptions.Item>
        </Descriptions>
        <Divider />
        <VirementsTable
          virements={budget?.virements}
          headerTitle={`Virements from / to ${budget?.budgetCategory?.name}`}
          toolBarRender={() => [
            !projectFrozen && (
              <Link to={`/projects/${projectId}/budget-virement/virements/add`}>
                <Button type="primary" icon={<PlusOutlined />}>
                  Apply for Virement
                </Button>
              </Link>
            ),
          ]}
          options={false}
        />
      </PageContainer>
    </ProjectHeader>
  );
};

export default Budget;
